import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { DragSource } from 'react-dnd';
import { compose } from 'react-apollo';

import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

import FilenameWithIcon from '../../UI/FilenameWithIcon';
import DeleteIcon from 'material-ui/svg-icons/navigation/cancel';

import styles from './PaperForm.css';

const selectStyle = {
    height: '32px',
    fontSize: '14px',
};

const nonEditableSelectStyle = {
    cursor: 'auto',
    height: '32px',
    fontSize: '14px',
};

const selectUnderlineStyle = {
    bottom: '-4px',
};

const underlineDisabledStyle = {
    borderBottom: '1px solid rgb(224, 224, 224)',
};

const hintStyle = {
    top: '12px',
};

const deleteStyle = {
    height: '20px',
    width: '20px',
};

const errorStyle = {
    fontSize: '10px',
    top: '2px',
};

class PaperForm extends Component {
    handleRoundChange = (event, key, value) => {
        const { index, onPaperChange } = this.props;

        onPaperChange(index, 'round', value);
    };

    handleLevelChange = (event, key, value) => {
        const { index, onPaperChange } = this.props;

        onPaperChange(index, 'level', value);
    };

    handleDeleteClick = () => {
        this.props.onDelete(this.props.index);
    };

    handleOpenClick = () => {
        this.props.onOpenClick(this.props.index);
    };

    render() {
        const {
            paper,
            intl: { formatMessage },
            connectDragSource,
            editable,
            participantIndex,
            season,
        } = this.props;

        const hasParticipant = participantIndex || participantIndex === 0;

        return connectDragSource(
            <div className={styles.paper}>
                <SelectField
                    value={paper.round}
                    autoWidth={true}
                    className={styles.select}
                    style={editable ? selectStyle : nonEditableSelectStyle}
                    underlineStyle={selectUnderlineStyle}
                    underlineDisabledStyle={underlineDisabledStyle}
                    hintText={formatMessage({ id: 'PaperForm.round' })}
                    hintStyle={hintStyle}
                    onChange={this.handleRoundChange}
                    disabled={!editable}
                    errorText={
                        hasParticipant && !paper.round
                            ? formatMessage({ id: 'EnterData.required' }).toLowerCase()
                            : null
                    }
                    errorStyle={errorStyle}
                >
                    <MenuItem
                        value={season === 'fall' ? 'p' : 't'}
                        primaryText={formatMessage({ id: 'ParticipantList.round.p' })}
                    />
                    <MenuItem
                        value={season === 'fall' ? 'm' : 'v'}
                        primaryText={formatMessage({ id: 'ParticipantList.round.m' })}
                    />
                </SelectField>
                <SelectField
                    value={paper.level}
                    autoWidth={true}
                    className={styles.select}
                    style={editable ? selectStyle : nonEditableSelectStyle}
                    underlineStyle={selectUnderlineStyle}
                    underlineDisabledStyle={underlineDisabledStyle}
                    hintText={formatMessage({ id: 'PaperForm.level' })}
                    hintStyle={hintStyle}
                    onChange={this.handleLevelChange}
                    disabled={!editable}
                    errorText={
                        hasParticipant && !paper.level
                            ? formatMessage({ id: 'EnterData.required' }).toLowerCase()
                            : null
                    }
                    errorStyle={errorStyle}
                >
                    <MenuItem value="junior" primaryText={formatMessage({ id: 'Report.level.junior' })} />
                    <MenuItem value="senior" primaryText={formatMessage({ id: 'Report.level.senior' })} />
                </SelectField>
                <FilenameWithIcon
                    filename={paper.filename}
                    className={styles.filename}
                    iconClassName={styles.fileIcon}
                    onClick={this.handleOpenClick}
                />
                {editable && (
                    <DeleteIcon style={deleteStyle} onClick={this.handleDeleteClick} className={styles.delete} />
                )}
            </div>
        );
    }
}

export default compose(
    injectIntl,
    DragSource(
        'paper',
        {
            beginDrag: ({ paper, participantIndex }) => ({ paper, participantIndex }),
        },
        connect => ({ connectDragSource: connect.dragSource() })
    )
)(PaperForm);



// WEBPACK FOOTER //
// ./src/Components/PaperForm/PaperForm.js